export default function (props: any) {
    return (
        <svg width="1120px" height="601px" viewBox="0 0 1120 601" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <defs>
                <radialGradient
                    cx="50%"
                    cy="53.443874%"
                    fx="50%"
                    fy="53.443874%"
                    r="219.013096%"
                    gradientTransform="translate(0.500000,0.534439),scale(0.535714,1.000000),rotate(0.620199),scale(1.000000,0.691373),translate(-0.500000,-0.534439)"
                    id="radialGradient-1"
                >
                    <stop stopColor="#E2A659" offset="0%"></stop>
                    <stop stopColor="#9C651D" offset="100%"></stop>
                </radialGradient>
                <rect id="path-2" x="0" y="0" width="1120" height="600"></rect>
            </defs>
            <g id="V1.2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="River-2-详情页" transform="translate(-400.000000, -14269.000000)">
                    <g id="编组-36" transform="translate(400.000000, 14047.176471)">
                        <g id="便携-+-便携-蒙版" transform="translate(0.000000, 222.000000)">
                            <mask id="mask-3" fill="white">
                                <use xlinkHref="#path-2"></use>
                            </mask>
                            <use id="蒙版" fill="url(#radialGradient-1)" xlinkHref="#path-2"></use>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
